import { render, staticRenderFns } from "./PlaceDocuments.vue?vue&type=template&id=6d242d0d"
import script from "./PlaceDocuments.vue?vue&type=script&lang=js"
export * from "./PlaceDocuments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports